
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import {
  collection,
  query,
  orderBy,
  onSnapshot
} from 'firebase/firestore';

function ListUsers() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilter, setDateFilter] = useState('');

  const [currentPage, setCurrentPage] = useState(1);

  const USERS_PER_PAGE = 50;

  useEffect(() => {
    const q = query(
      collection(db, 'users'),
      orderBy('lastLogin', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setUsers(data);
      setFilteredUsers(data);
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    let result = [...users];

    // Search by Phone Number
    if (searchTerm) {
      result = result.filter(user =>
        user.phone?.includes(searchTerm)
      );
    }

    // Filter by Last Login Date
    if (dateFilter) {
      result = result.filter(user => {
        if (!user.lastLogin) return false;

        const loginDate = user.lastLogin
          ?.toDate()
          .toISOString()
          .split('T')[0];

        return loginDate === dateFilter;
      });
    }

    setFilteredUsers(result);
    setCurrentPage(1);
  }, [searchTerm, dateFilter, users]);

  // Pagination
  const indexOfLastUser = currentPage * USERS_PER_PAGE;
  const indexOfFirstUser = indexOfLastUser - USERS_PER_PAGE;

  const currentUsers = filteredUsers.slice(
    indexOfFirstUser,
    indexOfLastUser
  );

  const totalPages = Math.ceil(
    filteredUsers.length / USERS_PER_PAGE
  );

  return (
    <div className="users-container">

      {/* Filter Bar */}
      <div className="filter-bar">

        <div className="search-box">
          <i className="fas fa-search"></i>
          <input
            type="text"
            placeholder="Search by Phone Number..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
          />
        </div>

        <div className="filter-options">
          <input
            type="date"
            value={dateFilter}
            onChange={(e) =>
              setDateFilter(e.target.value)
            }
          />

          {(searchTerm || dateFilter) && (
            <button
              className="clear-btn"
              onClick={() => {
                setSearchTerm('');
                setDateFilter('');
              }}
            >
              Clear
            </button>
          )}
        </div>

      </div>

      {/* Users Table */}
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Name</th>
              <th>Phone Number</th>
              <th>Last Login</th>
              <th>Status</th>
              <th>Notify</th>
            </tr>
          </thead>

          <tbody>

            {currentUsers.length > 0 ? (
              currentUsers.map((user, index) => (
                <tr key={user.id}>

                  <td>
                    {indexOfFirstUser + index + 1}
                  </td>

                  <td>
                    <strong>
                      {user.fullName || 'N/A'}
                    </strong>
                  </td>

                  <td>{user.phone}</td>

                  <td>
                    {user.lastLogin
                      ? user.lastLogin
                          .toDate()
                          .toLocaleString()
                      : 'Never'}
                  </td>

                  <td>
                    <span
                      className={`status-badge ${
                        user.status === 'Active'
                          ? 'delivered'
                          : 'cancelled'
                      }`}
                    >
                      {user.status || 'Active'}
                    </span>
                  </td>

                  <td>
                    <button
                      className="view-btn-icon"
                      title="Send Notification"
                    >
                      <i className="fas fa-bell"></i>
                    </button>
                  </td>

                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  style={{
                    textAlign: 'center',
                    padding: '30px'
                  }}
                >
                  No Users Found
                </td>
              </tr>
            )}

          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            marginTop: '20px'
          }}
        >

          <button
            className="submit-btn"
            disabled={currentPage === 1}
            onClick={() =>
              setCurrentPage(prev => prev - 1)
            }
          >
            Previous
          </button>

          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: '600'
            }}
          >
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="submit-btn"
            disabled={currentPage === totalPages}
            onClick={() =>
              setCurrentPage(prev => prev + 1)
            }
          >
            Next
          </button>

        </div>
      )}
    </div>
  );
}

export default ListUsers;

